import React, {useState} from 'react';

import DomainTablePage from '../../components/domainTablePage.js'
import { RtResponseHeaderWebsitesPageResult } from '../../../../server/routes/response-header.js';

// Interface for component props
interface ResponseHeaderWebsitesProps {
    server: string;
    pageData: unknown;
}

export default function ResponseHeaderWebsites({server, pageData}: ResponseHeaderWebsitesProps) {

	let [data, setData] = useState(pageData as RtResponseHeaderWebsitesPageResult);

	return (
        <DomainTablePage 
            domainList={data.TechnologyDomains}
        />
	)
}
